(function (Drupal) {
  Drupal.behaviors.messageCookie = {
    attach: function (context, settings) {
      const modals = context.querySelectorAll(
        ".page-node-type-home .info-popup"
      );
      modals.forEach((modal) => {
        if (!modal.dataset.messageCookieProcessed) {
          modal.dataset.messageCookieProcessed = "true";

          const h2Element = modal.querySelector("h2");
          const cookieName = h2Element
            ? h2Element.getAttribute("data-cookie")
            : null;
          if (cookieName && !document.cookie.includes(`${cookieName}=yes`)) {
            modal.classList.add("open");
          }

          const closeButtons = modal.querySelectorAll(
            ".modal .close, .modal-content a"
          );
          closeButtons.forEach((button) => {
            button.addEventListener("click", () => {
              modal.classList.remove("open");
              document.cookie = `${cookieName}=yes; path=/`;
            });
          });

          const modalContent = modal.querySelector(".modal-content");
          if (modalContent) {
            modalContent.addEventListener("click", (e) => {
              e.stopPropagation();
            });
          }

          modal.addEventListener("click", () => {
            modal.classList.remove("open");
            document.cookie = `${cookieName}=yes; path=/`;
          });
        }
      });
    },
  };
})(Drupal);
